import { ArtifactGenerator } from './ArtifactGenerator';

export class BlogPostGenerator extends ArtifactGenerator {
  generatePrompt(): string {
    return `You are an expert technical blog writer who specializes in creating engaging, informative content.
I will provide a set of ideas below, and I'd like you to create a comprehensive blog post.

Context and Ideas:

${this.getIdeaHierarchy()}

Please create an engaging blog post that follows these guidelines:

Structure:
1. Compelling headline that captures attention and includes relevant keywords
2. Strong introduction that hooks the reader and sets up the topic
3. Clear subheadings that break up the content logically
4. Engaging body content with real-world examples and use cases
5. Practical takeaways or next steps
6. Conclusion that ties everything together

Content Requirements:
- Write in a conversational yet professional tone
- Include relevant technical details without being overwhelming
- Use code snippets or examples where appropriate
- Break down complex concepts into digestible parts
- Include relevant statistics or data points
- Address potential questions or concerns
- Provide actionable insights

Formatting:
- Use markdown formatting for better readability
- Include appropriate headings (H1, H2, H3)
- Use bullet points and numbered lists where appropriate
- Include blockquotes for important points
- Format code snippets with appropriate syntax highlighting
- Keep paragraphs concise and focused

Additional Elements:
- Add a "Key Takeaways" section
- Include a "Prerequisites" section if relevant
- Add a "Further Reading" section
- Include relevant internal and external links
- Add image placeholders with descriptive captions
- Include a call-to-action at the end

The blog post should be comprehensive but engaging, maintaining a balance between technical depth and accessibility. Aim for a length of 1500-2000 words.

Generate the complete blog post now, using proper markdown formatting and maintaining an engaging, informative tone.`;
  }

  protected getIdeaHierarchy(): string {
    return this.ideas.map((idea, index) => {
      let ideaString = `${index + 1}. ${idea.content}`;
      
      if (idea.children.length > 0) {
        ideaString += '\n' + idea.children.map(child => `- ${child.content}`).join('\n');
      }
      
      return ideaString;
    }).join('\n\n');
  }
}
